module.exports = __webpack_public_path__ + "static/pay-success.734e4bfb.png";